module.exports = __webpack_public_path__ + "static/media/import-icon.07dbd97f.svg";